import axios from 'axios'

const apiUrl = 'https://texttospeech.googleapis.com/v1/text:synthesize?key=AIzaSyDICjhe0WhUQhGrhYA1TED20NxD1LXJrF0'

const headers = {
    'Content-Type': 'application/json'
}

export default {
    generateSpeech(text, voiceSpeed = 0.75) {
        const data = {
            input      : {
                text: text
            },
            voice      : {
                languageCode: 'ja-JP',
                name        : 'ja-JP-Wavenet-A'
            },
            audioConfig: {
                speakingRate : voiceSpeed,
                audioEncoding: 'MP3'
            }
        }

        return axios.post(apiUrl, data, {headers: headers})
            .then(response => {
                return response.data.audioContent
            })
            .catch(error => {
                console.log(error)
            })
    }
}
